import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

/*
  Using interceptors is all about changing outgoing requests and incoming responses
  Here we are using it for logging
*/
@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do((event: HttpEvent<any>) => {
      // console.log({
      //   url: req.url,
      //   method: req.method,
      //   headers: req.headers,
      //   params: req.params,
      //   body: req.body,
      //   response: event
      // });
    })
    .catch((httpErrorResponse: HttpErrorResponse) => {
      console.error('Error', httpErrorResponse);
      return Observable.throw(httpErrorResponse);
    });
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/interceptors/interceptors.logging.ts